"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandlerProvider = void 0;
const Sentry = __importStar(require("@sentry/browser"));
const typed_primitives_1 = require("@sixfold/typed-primitives");
const React = __importStar(require("react"));
const error_context_1 = require("./error_context");
const ErrorHandlerProvider = ({ sentryOptions, children, }) => {
    const isSentryEnabled = sentryOptions?.isEnabled === true;
    const sentry = isSentryEnabled ? Sentry : undefined;
    React.useEffect(() => {
        if (!isSentryEnabled) {
            return;
        }
        Sentry.init({
            dsn: sentryOptions.dsn,
            release: sentryOptions.release,
            environment: sentryOptions.environment,
            ignoreErrors: sentryOptions?.ignoreErrors,
            beforeSend: sentryOptions?.beforeSend,
            denyUrls: sentryOptions?.denyUrls,
            integrations: [
                ...(sentryOptions.isHttpClientCaptureEnabled === true ? [Sentry.httpClientIntegration()] : []),
                ...((0, typed_primitives_1.notNil)(sentryOptions?.thirdPartyErrorFilter)
                    ? [
                        Sentry.thirdPartyErrorFilterIntegration({
                            filterKeys: [sentryOptions?.thirdPartyErrorFilter.applicationKey],
                            behaviour: sentryOptions?.thirdPartyErrorFilter.behaviour ??
                                'drop-error-if-exclusively-contains-third-party-frames',
                        }),
                    ]
                    : []),
            ],
        });
    }, [
        isSentryEnabled,
        sentryOptions?.release,
        sentryOptions?.environment,
        sentryOptions?.dsn,
        sentryOptions?.ignoreErrors,
    ]);
    const errorHandler = React.useMemo(() => {
        return {
            captureError: (error, context) => {
                console.error(error);
                sentry?.captureException(error, context);
            },
        };
    }, [sentry]);
    return React.createElement(error_context_1.ErrorContext.Provider, { value: errorHandler }, children);
};
exports.ErrorHandlerProvider = ErrorHandlerProvider;
//# sourceMappingURL=error_handler.js.map